module.exports = __webpack_public_path__ + "img/prod-mat_s.ac8bb472.svg";